export const entpCptToStaff: Record<string, string> = {
  "10120": "Grant, Laura",
  "11441": "Resto-Romero, Monica",
  "11446": "Resto-Romero, Monica",
  "11644": "Resto-Romero, Monica",
  "11900": "Grant, Laura",
  "14061": "Resto-Romero, Monica",
  "15630": "Resto-Romero, Monica",
  "15740": "Resto-Romero, Monica",
  "15823": "Resto-Romero, Monica",
  "15839": "Resto-Romero, Monica",
  "20922": "Resto-Romero, Monica",
  "21012": "Resto-Romero, Monica",
  "21016": "Resto-Romero, Monica",
  "21235": "Resto-Romero, Monica",
  "21320": "Resto-Romero, Monica",
  "21337": "Resto-Romero, Monica",
  "21552": "Resto-Romero, Monica",
  "21554": "Resto-Romero, Monica",
  "21555": "Resto-Romero, Monica",
  "21556": "Resto-Romero, Monica",
  "30115": "Grant, Laura",
  "30117": "Grant, Laura",
  "30130": "Resto-Romero, Monica",
  "30140": "Resto-Romero, Monica",
  "30310": "Resto-Romero, Monica",
  "30420": "Resto-Romero, Monica",
  "30465": "Resto-Romero, Monica",
  "30469": "Grant, Laura",
  "30520": "Resto-Romero, Monica",
  "30560": "Grant, Laura",
  "30630": "Resto-Romero, Monica",
  "30801": "Grant, Laura",
  "30802": "Grant, Laura",
  "31032": "Resto-Romero, Monica",
  "31225": "Resto-Romero, Monica",
  "31231": "Resto-Romero, Monica",
  "31237": "Grant, Laura",
  "31238": "Grant, Laura",
  "31240": "Grant, Laura",
  "31241": "Resto-Romero, Monica",
  "31242": "Grant, Laura",
  "31253": "Resto-Romero, Monica",
  "31254": "Grant, Laura",
  "31255": "Grant, Laura",
  "31256": "Resto-Romero, Monica",
  "31257": "Resto-Romero, Monica",
  "31259": "Resto-Romero, Monica",
  "31267": "Resto-Romero, Monica",
  "31276": "Resto-Romero, Monica",
  "31287": "Resto-Romero, Monica",
  "31288": "Resto-Romero, Monica",
  "31292": "Resto-Romero, Monica",
  "31295": "Grant, Laura",
  "31296": "Grant, Laura",
  "31297": "Grant, Laura",
  "31298": "Grant, Laura",
  "31515": "Resto-Romero, Monica",
  "31525": "Resto-Romero, Monica",
  "31528": "Resto-Romero, Monica",
  "31531": "Resto-Romero, Monica",
  "31535": "Resto-Romero, Monica",
  "31536": "Resto-Romero, Monica",
  "31541": "Resto-Romero, Monica",
  "31570": "Resto-Romero, Monica",
  "31571": "Resto-Romero, Monica",
  "31575": "Resto-Romero, Monica",
  "31576": "Resto-Romero, Monica",
  "31600": "Resto-Romero, Monica",
  "31622": "Resto-Romero, Monica",
  "31625": "Resto-Romero, Monica",
  "31630": "Resto-Romero, Monica",
  "38510": "Resto-Romero, Monica",
  "38520": "Resto-Romero, Monica",
  "38700": "Resto-Romero, Monica",
  "38720": "Resto-Romero, Monica",
  "38724": "Resto-Romero, Monica",
  "39000": "Resto-Romero, Monica",
  "40490": "Grant, Laura",
  "40525": "Resto-Romero, Monica",
  "40810": "Resto-Romero, Monica",
  "40812": "Resto-Romero, Monica",
  "40814": "Resto-Romero, Monica",
  "40820": "Grant, Laura",
  "41010": "Grant, Laura",
  "41100": "Grant, Laura",
  "41110": "Grant, Laura",
  "41112": "Grant, Laura",
  "42100": "Grant, Laura",
  "42104": "Grant, Laura",
  "42140": "Grant, Laura",
  "42145": "Resto-Romero, Monica",
  "42330": "Grant, Laura",
  "42410": "Resto-Romero, Monica",
  "42415": "Resto-Romero, Monica",
  "42420": "Resto-Romero, Monica",
  "42425": "Resto-Romero, Monica",
  "42440": "Resto-Romero, Monica",
  "42500": "Grant, Laura",
  "42650": "Grant, Laura",
  "42800": "Grant, Laura",
  "42808": "Resto-Romero, Monica",
  "42810": "Resto-Romero, Monica",
  "42820": "Resto-Romero, Monica",
  "42821": "Resto-Romero, Monica",
  "42825": "Resto-Romero, Monica",
  "42826": "Resto-Romero, Monica",
  "42830": "Resto-Romero, Monica",
  "42831": "Resto-Romero, Monica",
  "42890": "Resto-Romero, Monica",
  "42950": "Resto-Romero, Monica",
  "42975": "Grant, Laura",
  "43191": "Resto-Romero, Monica",
  "43192": "Resto-Romero, Monica",
  "43194": "Resto-Romero, Monica",
  "60212": "Resto-Romero, Monica",
  "60220": "Resto-Romero, Monica",
  "60240": "Resto-Romero, Monica",
  "60252": "Resto-Romero, Monica",
  "60500": "Resto-Romero, Monica",
  "60512": "Resto-Romero, Monica",
  "60520": "Resto-Romero, Monica",
  "61580": "Resto-Romero, Monica",
  "61605": "Resto-Romero, Monica",
  "61618": "Resto-Romero, Monica",
  "61782": "Resto-Romero, Monica",
  "61886": "Resto-Romero, Monica",
  "64582": "Resto-Romero, Monica",
  "64583": "Resto-Romero, Monica",
  "67414": "Resto-Romero, Monica",
  "69005": "Resto-Romero, Monica",
  "69110": "Resto-Romero, Monica",
  "69145": "Resto-Romero, Monica",
  "69205": "Resto-Romero, Monica",
  "69300": "Resto-Romero, Monica",
  "69420": "Resto-Romero, Monica",
  "69433": "Grant, Laura",
  "69436": "Resto-Romero, Monica",
  "69610": "Resto-Romero, Monica",
  "69620": "Resto-Romero, Monica",
  "69705": "Grant, Laura",
  "69706": "Grant, Laura",
  "69801": "Grant, Laura",
  "70450": "Grant, Laura",
  "70480": "Grant, Laura",
  "70486": "Grant, Laura",
  "70490": "Grant, Laura",
  "70491": "Grant, Laura",
  "71250": "Grant, Laura",
  "74176": "Grant, Laura",
  "77011": "Grant, Laura",
  "95782": "Badell, Priscilla",
  "95800": "No assignment, close document",
  "95805": "Badell, Priscilla",
  "95810": "Badell, Priscilla",
  "95811": "Badell, Priscilla",
  "95819": "No assignment, close document",
  "95865": "Resto-Romero, Monica",
  "95868": "Resto-Romero, Monica",
  "95940": "Resto-Romero, Monica",
  "E0486": "USER,CPAP",
  "E0681": "USER,CPAP",
  "G0399": "Badell, Priscilla",
  "J1100": "Grant, Laura",
  "J3490": "Grant, Laura",
  "Q9967": "Grant, Laura",
  "S1091": "Grant, Laura",
  "E0601": "USER,CPAP",
  "A7030": "USER,CPAP",
};
